var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vuestic-widget',{attrs:{"header-text":"Consolidado Por Periodo"}},[_c('select-periodo',{on:{"sendFiltros":_vm.getDataFromPeriodo}}),_c('tabla-periodo-consolidado',{attrs:{"datos":_vm.datos}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }